<tax-modal-header>cto.add.modules.title</tax-modal-header>

<tax-modal-content>
  <div data-qa-checkbox="select-all" class="ui-kit-centering-string">
    <input
      class="select_all"
      [(ngModel)]="selectAll"
      (change)="updateAll($event)"
      id="selectAll"
      type="checkbox"
      data-qa="checkbox"
    />
    <label for="selectAll" data-qa="checkbox-label-text">
      {{ 'group.modal.retail.place.selectall' | translate }}
    </label>
  </div>

  <div class="modal-body-wrapper">
    <div class="modal_body" taxScrollbar data-qa="permissions-list">
      <div class="modal_body__items" data-qa-checkbox="permission-generate_token">
        <input
          id="token"
          type="checkbox"
          [(ngModel)]="modules['cto.permission.generate_token']"
          (change)="checkboxChange()"
          data-qa="checkbox"
        />
        <label for="token" data-qa="checkbox-label-text">{{
          'cto.permission.generate_token' | translate
        }}</label>
      </div>
      <div class="modal_body__items" data-qa-checkbox="permission-view_balance">
        <input
          id="account"
          type="checkbox"
          [(ngModel)]="modules['cto.permission.view_balance']"
          (change)="checkboxChange()"
          data-qa="checkbox"
        />
        <label for="account" data-qa="checkbox-label-text">{{
          'cto.permission.view_balance' | translate
        }}</label>
      </div>
    </div>
  </div>
</tax-modal-content>

<tax-modal-footer>
  <button data-qa-button="close-modal" class="button_link" (click)="closeModal()">
    {{ 'button.cancel' | translate }}
  </button>
  <button data-qa-button="save" class="button_blue" (click)="saveSelectedModules()">
    {{ 'modal.select' | translate }}
  </button>
</tax-modal-footer>
